import { config } from 'config/constants';
import { IAppReducer } from 'models';
import { useSelector } from 'react-redux';

export const CreateInsurance = () => {
  const { authReducer: user } = useSelector((state: IAppReducer) => state);

  const authId = user.uid;
  const jwt = user.accessToken;
  const agentAuthId = user.agentAuthData ? user.agentAuthData.uid : '';
  const companyId = user.companyId;

  // const iframeUrl = `${
  //   config.soda.sodaVercelUrl
  // }/insurance?authId=${encodeURIComponent(authId)}&token=${encodeURIComponent(
  //   jwt
  // )}&agentAuthId=${agentAuthId}&companyId=${companyId}`;

  const iframeUrl = `${
    config.soda.sodaUrl
  }/checkout-insurance?authId=${encodeURIComponent(
    authId
  )}&token=${encodeURIComponent(
    jwt
  )}&agentAuthId=${agentAuthId}&companyId=${companyId}`;

  return (
    <div style={{ height: '100vh', width: '100%' }}>
      <iframe
        src={iframeUrl}
        width="100%"
        height="100%"
        title="Crear seguro"
        style={{ border: 'none' }}
      />
    </div>
  );
};
